import { Button, Callout, Dialog, EmptyState, Icon, Icons, Intent, ListItem, QueryList, Spinner, Tag } from "construct-ui";
import userSearchModal from "../../models/common/user-search.modal";
import languageModel from "../../models/language.model";
import ViewBase from "../../views/view-base.view";
import SiteResultViewComponent from "./site-result-view";

/**
 * @deprecated
 * 
 * Instead, please use 
 * ```
 * m(SelectSiteSearchInputComponent)
 * // src/app/components/site/select-site-search-input.component.js
 * ```
 */
export default function SelectSiteComponent() {
  ViewBase.call(this);

  const DEFAULT_ONCHANGE = (selecteditems) => { console.log('SelectSiteComponent: onChange(selectedItems)') };
  const TITLE_SEPARATOR = ', ';

  let filterable = false;
  let searchable = true;
  let isOpen = false;
  let isSearching = false;
  let itemList;
  let selectedItemList = [];
  let filter = { siteIdOrName: '', countryCode: '' }
  let isResultViewOpen = false;

  let clearSelectedItemList = (onChange) => () => {
    selectedItemList = [];
    onChange(selectedItemList);
  }

  let upload = () => {
    isResultViewOpen = true;
  }

  let search = () => {
    isSearching = true;
    userSearchModal.getStoreList(
      (result) => {
        itemList = [];
        if (result) {
          result.map(e => {
            itemList.push({ ...e });
          });
        }
        isSearching = false;
      },
      (error) => {
        isSearching = false;
        this.handleError(error);
      },
      filter
    )
  }

  let clearSearchFilter = () => {
    filter.siteIdOrName = '';
    itemList = undefined;
  }

  function renderItem(item, index) {
    return m(ListItem, {
      allowOnContentClick: true,
      label: `${item.name} - [${item.code}]`,
      selected: (selectedItemList.findIndex(i => i.code === item.code) > -1),
    })
  }

  const handleSelect = (onChange) => (item) => {
    if (item.code == "") {
      if (selectedItemList.length > 0) {
        selectedItemList.splice(0, selectedItemList.length);
      } else {
        itemList.map((item, index) => {
          if (index > 0 && selectedItemList.findIndex(i => i.code === item.code) < 0) {
            selectedItemList.push(item);
          }
        });
      }
    } else if (selectedItemList.findIndex(i => i.code === item.code) > -1) {
      selectedItemList.splice(selectedItemList.findIndex(i => i.code === item.code), 1);
    } else {
      selectedItemList.push(item);
    }

    onChange(selectedItemList);
  }

  function renderSelectedLabel(item) {
    if (item.name) {
      return item.name;
    }

    let itemName = itemList?.find(i => i.code === item.code)?.name;
    if (itemName) {
      item.name = itemName;
      return itemName;
    }

    return '';
  }

  let renderLabel = (_selectedItemList) => {
    return (_selectedItemList && _selectedItemList.length > 0)
      ? _selectedItemList.length + ' ' + this.getText("LT00000308", "item(s) selected")
      : ''
  }

  const renderTitle = _selectedItemList => {
    return (_selectedItemList && _selectedItemList.length > 0)
      ? _selectedItemList.map(sites => sites.name).join(TITLE_SEPARATOR)
      : ''
  }

  const readOnly = (event) => {
    event.preventDefault();
    event.stopImmediatePropogation();
  }

  let Content = {
    view: ({ attrs: { onChange } }) => {
      return m('.container',
        // Selected section
        m('.d-flex.justify-content-between.gap-2',
          m('.d-flex.gap-2',
            m('label.form-label', this.getText("LT00000346", "Selected items")),
            (selectedItemList && selectedItemList.length > 0)
              ? [m('span', ':'), m('span', selectedItemList.length + ' ' + this.getText("LT00000344", "items"))]
              : ''
          ),
          m('.d-flex.gap-2',
            m('a.btn.btn-link.p-0', {
              onclick: clearSelectedItemList(onChange)
            }, this.getText("LT00000345", "Clear all")),
          )
        ),
        m('.card.mb-3',
          m('.card-body.overflow-auto', { style: 'min-height: 51px; max-height: 82px;' },
            m('.d-flex.flex-wrap.gap-1',
              (selectedItemList && selectedItemList.length > 0)
                ? selectedItemList.map(i => [
                  m(Tag, {
                    class: 'm-0',
                    label: renderSelectedLabel(i),
                    onRemove: e => {
                      let idx = selectedItemList.findIndex(s => s.code === i.code);
                      if (idx > -1) {
                        selectedItemList.splice(idx, 1);
                        onChange(selectedItemList);
                      }
                    }
                  })
                ])
                : m(EmptyState, {
                  content: languageModel.getText("LT00000318", "No items selected. Please search and select from the section below."),
                  style: 'color: var(--is-inactive-gray)',
                })
            ),
          )
        ),
        // Search section
        m('.card.mb-3',
          m('.card-body',
            m('.row.g-4',
              searchable && m('.col-12',
                m('.d-flex.flex-wrap.justify-content-end.gap-2',
                  m('.flex-grow-1', { style: 'min-width: 60%;' },
                    m('input.form-control[type=text]', {
                      placeholder: languageModel.getText("LT00000321", "Site Code / Name"),
                      onchange: e => { filter.siteIdOrName = e.target.value },
                      value: filter.siteIdOrName,
                    }),
                  ),
                  m('.d-flex.gap-2',
                    m(Button, {
                      label: this.getText("LT00000001", "Search"),
                      intent: Intent.PRIMARY,
                      loading: isSearching,
                      onclick: search,
                    }),
                    m(Button, {
                      label: this.getText("LT00000197", "Execl Upload"),
                      intent: Intent.PRIMARY,
                      iconLeft: Icons.UPLOAD,
                      loading: isSearching,
                      onclick: upload,
                    }),
                    m(Button, {
                      label: this.getText("LT00000031", "Clear"),
                      intent: Intent.PRIMARY,
                      outlined: true,
                      onclick: clearSearchFilter,
                    })

                  ),
                ),
              ),
              m('.col-12.position-relative', { style: 'min-height: 180px;' },
                itemList && itemList.length > 0 ?
                  m(QueryList, {
                    filterable: filterable,
                    disableArrowKeys: true,
                    items: itemList,
                    itemRender: renderItem,
                    itemListPredicate: (query, items) => items.filter(i => i.name.toLowerCase().includes(query.toLowerCase())),
                    onSelect: handleSelect(onChange),
                    listAttrs: {
                      style: 'height: calc(100vh - 520px);'
                    }
                  }) :
                  m(EmptyState, {
                    icon: Icons.ARCHIVE,
                    content: languageModel.getText("LT00000317", "No results found"),
                    fill: true,
                    style: 'color: #B5B5B5',
                  }),
                isSearching &&
                m(Spinner, {
                  active: isSearching,
                  background: true,
                  fill: true,
                  size: 'xl',
                })
              )
            )
          )
        ),
        itemList && itemList.length > 199 &&
        m(Callout, {
          content: languageModel.getText("LT00000320", "Only top 200 records are shown due to large result set"),
          icon: Icons.ALERT_CIRCLE,
          intent: Intent.WARNING,
        })
      )
    }
  }

  return {
    oninit: ({ attrs: {
      countryCode: _countryCode,
      filterable: _filterable = false,
      items: _items,
      searchable: _searchable = true,
      selectedItemList: _selectedItemList,
    } }) => {
      filter.countryCode = _countryCode ?? '';
      filterable = _filterable;
      searchable = _searchable;
      selectedItemList = _selectedItemList ?? [];

      // Only allow external list if not searchable
      if (!searchable) {
        itemList = _items ?? []
      }

      search();
    },
    onupdate: ({ attrs: {
      countryCode: _countryCode,
      items: _items,
      selectedItemList: _selectedItemList,
    } }) => {
      // Only allow external list if not searchable
      if (!searchable) {
        itemList = _items ?? []
      }

      if ((typeof _countryCode === 'string' || _countryCode instanceof String)
        && filter.countryCode !== _countryCode) {
        filter.countryCode = _countryCode;
        search();
      }

      selectedItemList = _selectedItemList ?? selectedItemList;
    },
    view: ({ attrs: {
      class: _class = '',
      disabled = false,
      fluid = true,
      id = null,
      onChange = DEFAULT_ONCHANGE,
      outlined = true,
      placeholder,
      required = false,
      selectedItemList,
    } }) => {
      return [
        m('.select-input-component.d-flex.justify-content-between.align-items-center.form-control.form-control-bg', {
          class: disabled ? 'disabled ' : '',
          onclick: () => {
            if (!disabled) {
              isOpen = !isOpen;
            }
          }
        },
          m('input.flex-fill.text-start.ps-0', {
            id,
            disabled,
            required,
            type: 'text',
            placeholder: placeholder ?? this.getText("LT00000201", "Please select"),
            oninput: readOnly,
            style: {
              width: 'inherit',
              'overflow-x': 'hidden',
              'text-overflow': 'ellipsis',
              border: 'none',
              background: 'transparent'
            },
            value: renderLabel(selectedItemList),
            title: renderTitle(selectedItemList)
          }),
          m(Icon, { name: Icons.LIST, intent: Intent.PRIMARY })
        ),
        isOpen &&
        m(Dialog, {
          class: 'cui-dialog-l',
          closeOnOutsideClick: false,
          isOpen: isOpen,
          onClose: () => isOpen = false,
          title: this.getText("LT00000071", "Site"),
          content: m(Content, { onChange })
        }),
        m(Dialog, {
          class: 'cui-dialog-xxl',
          isOpen: isResultViewOpen,
          closeOnOutsideClick: false,
          onClose: () => { isResultViewOpen = false; },
          title: this.getText("LT00000071", "Site") + " - " + this.getText("LT00000197", "Excel Upload"),
          content: m(SiteResultViewComponent, {
            onChange: (list) => {
              selectedItemList = list;
              onChange(list)
            },
            selectedItemList: selectedItemList
          }),
        }),
      ]
    }
  }
}
